import React, { FC, memo } from 'react';

import { useToggleOnAirWithIndicator } from '@/scenarios/legacy-player/components/feature-player/hooks/skin/use-toggle-on-air-with-indicator';
import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';

import { SessionStopMode } from '../../../SessionStop/SessionStop.types';
import { SessionStop } from '../../../SessionStop/SessionStop';

interface ChannelSessionStopScreenProps {
    contentId: string;
    onIsSessionStoppedChanged?: (isSessionStopped: boolean) => void;
}

export const ChannelSessionStopScreen: FC<ChannelSessionStopScreenProps> = memo(
    ({ contentId, onIsSessionStoppedChanged }) => {
        const { playingState } = usePlayingState();
        const { toggleOnAir, pause } = useToggleOnAirWithIndicator();

        return (
            <SessionStop
                play={toggleOnAir}
                pause={pause}
                playingState={playingState}
                contentId={contentId}
                mode={SessionStopMode.StopScreen}
                onIsSessionStoppedChanged={onIsSessionStoppedChanged}
            />
        );
    }
);
